import * as Common from '@/agiles/common';

export enum inquiryTypes {
    Instructions = 1,
    FeeAndContract,
    Defect,
    Request
}

export class SendInquiryQuery extends Common.Query {
  constructor(email: string, company: string, name: string, type: inquiryTypes, content: string, tenantId: string) {
    super('SendInquiryQuery', null);
    this.email = email;
    this.company = company;
    this.name = name;
    this.type = type;
    this.content = content;
    this.tenantId = tenantId;
  }
  public email: string = null;
  public company: string = null;
  public name: string = null;
  public type: inquiryTypes = null;
  public content: string = null;
  public tenantId: string = null;
}